import { PlusToMinusIcon, Typography, TypographyProps } from '@ag1/ui';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { isPreviewRouteView } from '@portal/shared/utils/previewRouteHelpers';
import { Collapse } from 'react-collapse';
import clsx from 'clsx';
import styles from '../../styles.module.scss';
import { CustomListItem } from '../types';

export const ListItem: React.FC<{
  item: CustomListItem;
  isOpen: boolean;
  onToggle: () => void;
  useBorderTop?: boolean;
  smallPadding?: boolean;
  headerTypographyProps: TypographyProps;
}> = ({
  item: { header, body },
  isOpen: isOpenProp,
  onToggle,
  useBorderTop,
  smallPadding,
  headerTypographyProps
}) => {
  const router = useRouter();
  const isOpen = useMemo(() => isOpenProp || isPreviewRouteView(router), [router, isOpenProp]);

  return (
    <div
      className={clsx(
        styles.listItem,
        useBorderTop && styles.topBorder,
        smallPadding && styles.smallPadding
      )}>
      <div className={styles.row}>
        <div
          className={styles.listToggle}
          role="button"
          data-gtm-skip-global
          onClick={onToggle}
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              onToggle();
            }
          }}>
          <Typography component="h4" weight="700" noPadding {...headerTypographyProps}>
            {header}
          </Typography>
          <PlusToMinusIcon isOpen={isOpen} className={styles.icon} />
        </div>
      </div>
      <Collapse isOpened={isOpen}>
        <Typography className={styles.text} variant="body" size="1" component="div" noPadding>
          {body}
        </Typography>
      </Collapse>
    </div>
  );
};
